import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { FaCog, FaSave } from 'react-icons/fa';
import Loading from '~/Components/Loading';
import {
  buscarParametrosContatosTeste,
  salvarParametrosContatosTeste,
} from '~/Services/Service';

const schema = Yup.object().shape({
  email_recuperacao: Yup.string()
    .required('E-mail de teste obrigatório')
    .email('E-mail inválido')
    .max(400, 'Máximo 400 caracteres'),
  telefone_recuperacao: Yup.string()
    .required('Telefone de teste obrigatório')
    .test('telefone-digitos', 'Telefone inválido (10 ou 11 dígitos)', value => {
      const digits = value ? value.replace(/\D/g, '') : '';
      return digits.length === 10 || digits.length === 11;
    }),
});

const ParametrosContatosTeste = () => {
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    let ativo = true;
    buscarParametrosContatosTeste()
      .then(data => {
        if (!ativo) return;
        setDados({
          email_recuperacao:
            data && data.email_recuperacao ? data.email_recuperacao : '',
          telefone_recuperacao:
            data && data.telefone_recuperacao ? data.telefone_recuperacao : '',
        });
      })
      .catch(err => {
        if (!ativo) return;
        const mensagem =
          err && err.message ? err.message : 'Erro ao carregar parâmetros.';
        toast.error(mensagem);
      })
      .finally(() => {
        if (ativo) setCarregando(false);
      });
    return () => {
      ativo = false;
    };
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    const digits = values.telefone_recuperacao
      ? values.telefone_recuperacao.replace(/\D/g, '')
      : '';
    const payload = {
      telefone_recuperacao: digits,
      email_recuperacao: values.email_recuperacao.trim(),
    };
    try {
      await salvarParametrosContatosTeste(payload);
      toast.success('Parâmetros atualizados com sucesso.');
      setDados({
        email_recuperacao: payload.email_recuperacao,
        telefone_recuperacao: payload.telefone_recuperacao,
      });
    } catch (err) {
      const mensagem =
        err && err.message ? err.message : 'Erro ao salvar parâmetros.';
      toast.error(mensagem);
    } finally {
      setSubmitting(false);
    }
  };

  if (carregando) {
    return <Loading />;
  }

  return (
    <Container fluid className="px-3 py-3">
      <Row
        className="py-3 mb-3 mx-auto justify-content-between align-items-center"
        style={{
          backgroundColor: '#0747a6',
          borderRadius: '8px',
          color: '#fff',
        }}
      >
        <Col className="d-flex align-items-center px-3">
          <FaCog className="mr-2" />
          <h4 className="mb-0">Contatos de Teste</h4>
        </Col>
      </Row>

      <Row>
        <Col xs={12} lg={8} xl={6} className="mx-auto">
          <Card
            className="border-0"
            style={{
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
            }}
          >
            <Card.Body>
              <Formik
                initialValues={
                  dados !== null
                    ? dados
                    : { email_recuperacao: '', telefone_recuperacao: '' }
                }
                validationSchema={schema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ isValid, isSubmitting }) => (
                  <FormikForm>
                    <Row>
                      <Col xs={12}>
                        <div className="form-group mb-3">
                          <label
                            className="small mb-1"
                            style={{ fontWeight: 500 }}
                            htmlFor="email_recuperacao"
                          >
                            E-mail de Teste
                          </label>
                          <Field
                            id="email_recuperacao"
                            name="email_recuperacao"
                            type="email"
                            className="form-control form-control-sm"
                            maxLength={400}
                            placeholder="Ex.: teste@setpar.com.br"
                          />
                          <ErrorMessage
                            name="email_recuperacao"
                            component="div"
                            className="text-danger small mt-1"
                          />
                          <small className="text-muted">Máximo 400 caracteres.</small>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className="form-group mb-3">
                          <label
                            className="small mb-1"
                            style={{ fontWeight: 500 }}
                            htmlFor="telefone_recuperacao"
                          >
                            Telefone de Teste
                          </label>
                          <Field
                            id="telefone_recuperacao"
                            name="telefone_recuperacao"
                            type="text"
                            className="form-control form-control-sm"
                            maxLength={20}
                            placeholder="Ex.: 17981967697"
                          />
                          <ErrorMessage
                            name="telefone_recuperacao"
                            component="div"
                            className="text-danger small mt-1"
                          />
                          <small className="text-muted">
                            10 ou 11 dígitos (apenas números).
                          </small>
                        </div>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end align-items-center mt-2">
                      <Button
                        type="submit"
                        variant="primary"
                        disabled={!isValid || isSubmitting}
                        className="d-flex align-items-center"
                      >
                        <FaSave className="mr-2" />
                        {isSubmitting ? 'Salvando...' : 'Salvar alterações'}
                      </Button>
                    </div>
                  </FormikForm>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ParametrosContatosTeste;
